module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "Home-Fanar.f0639bca.webp" + "?" + Date.now();